<template>
    <TabView v-model:activeIndex="text" :lazy="lazy" style="overflow: auto;">
        <slot>
            <TabPanel header="模拟">
                <div class="tw-tabview"></div>
            </TabPanel>
        </slot>
    </TabView>
</template>

<script>
import { computed } from 'vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

export default {
    name: 'tw-tabview',
    components: {
        TabView,
        TabPanel
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.activeIndex === null || props.activeIndex === undefined) ? 0 : props.activeIndex
            },
            set(value){
                context.emit('update:activeIndex', value)
            }
        })

        return {
            text
        }
    },
    props: {
        lazy: Boolean,
        activeIndex: {
            type: Number,
            default: 0
        }
    }
}

</script>